<div class="col-12 px-0 mt-2">
  <strong class="my-1 fz">Selecione o captcha para continuar</strong>
  <div class="captcha-responsive">
    <ngx-recaptcha2
      [siteKey]="recaptchaSiteKey"
      (success)="onSuccess($event)"
      (expired)="onExpired()"
      #captchaElem></ngx-recaptcha2>
  </div>
</div>
